import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Mail, Phone, MapPin } from 'lucide-react';
import { Container } from './ui/Container';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300" data-id="element-63">
      <Container className="py-12 md:py-16" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-65">
          <div className="col-span-1 md:col-span-1" data-id="element-66">
            <Link to="/" className="flex items-center space-x-2 mb-4" data-id="element-67">
              <ShieldCheck className="h-8 w-8 text-blue-500" data-id="element-68" />
              <span className="text-xl font-bold text-white" data-id="element-69">DanyCredit</span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed mb-6" data-id="element-70">
              Professional credit consulting and financial education to help you
              understand and improve your financial standing.
            </p>
          </div>

          <div data-id="element-71">
            <h3 className="text-white font-semibold mb-4" data-id="element-72">Services</h3>
            <ul className="space-y-3 text-sm" data-id="element-73">
              <li data-id="element-74">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-75">
                  Credit Profile Review
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-77">
                  Credit Education
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-79">
                  Financial Planning
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-81">
                  Readiness Consulting
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-82">
            <h3 className="text-white font-semibold mb-4" data-id="element-83">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-84">
              <li data-id="element-85">
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-id="element-86">
                  About Us
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-id="element-88">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-89">
            <h3 className="text-white font-semibold mb-4" data-id="element-90">Contact</h3>
            <ul className="space-y-3 text-sm" data-id="element-91">
              <li className="flex items-center" data-id="element-92">
                <Mail className="h-4 w-4 mr-2 text-blue-500" data-id="element-93" />
                <span data-id="element-94">info@danycredit.com</span>
              </li>
              <li className="flex items-center" data-id="element-95">
                <Phone className="h-4 w-4 mr-2 text-blue-500" data-id="element-96" />
                <span data-id="element-97">786-376-3985</span>
              </li>
              <li className="flex items-start" data-id="element-98">
                <MapPin className="h-4 w-4 mr-2 text-blue-500 mt-1" data-id="element-99" />
                <span data-id="element-100">
                  390 NE 191ST ST STE 8123
                  <br data-id="element-101" />
                  Miami, FL 33179
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 pb-6" data-id="element-102">
          <div className="flex flex-wrap justify-center gap-6 mb-6 text-xs" data-id="element-103">
            <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors" data-id="element-104">
              Privacy Policy
            </Link>
            <span className="text-slate-600" data-id="element-105">|</span>
            <Link to="/terms-and-conditions" className="hover:text-blue-400 transition-colors" data-id="element-106">
              Terms & Conditions
            </Link>
            <span className="text-slate-600" data-id="element-107">|</span>
            <Link to="/refund-policy" className="hover:text-blue-400 transition-colors" data-id="element-108">
              Refund Policy
            </Link>
          </div>

          <div className="text-xs text-slate-500 space-y-4" data-id="element-109">
            <p className="font-semibold text-slate-400" data-id="element-110">Disclaimer:</p>
            <p data-id="element-111">
              DanyCredit LLC provides educational and consulting services only.
              We do not guarantee specific outcomes, credit score increases,
              approvals, or financial results. We are not a credit bureau,
              lender, or law firm. Results vary by individual financial profile.
            </p>
            <p data-id="element-112">
              We do not provide "credit repair" services as defined by the
              Credit Repair Organizations Act (CROA). We do not dispute accurate
              negative items on your credit report. Our services are strictly
              limited to education, analysis, and strategic consulting.
            </p>
            <p className="pt-4 text-center" data-id="element-113">
              &copy; {new Date().getFullYear()} DanyCredit LLC. All rights
              reserved.
            </p>
          </div>
        </div>
      </Container>
    </footer>;
}